import { forEach, map, once } from "lodash-es";
import { inViewPort } from "./in-viewport";
var toTitlecase = function (str) { return map(str.toLowerCase().split(' '), function (word) { return word.charAt(0).toUpperCase() + word.slice(1); }).join(' '); };
window.addEventListener('load', function () {
    var tablepressElements = document.querySelectorAll('.tablepress');
    forEach(tablepressElements, function (tableElement) {
        var tableHeaderElements = tableElement.querySelectorAll('th');
        var tableRowElements = tableElement.querySelectorAll('tbody tr');
        var tableColumnText = map(tableHeaderElements, function (th) { return toTitlecase(th.innerText); });
        var wrapperElement = tableElement.parentElement;
        var scrollableIndicator = document.createElement('div');
        scrollableIndicator.classList.add('scrollable-indicator');
        scrollableIndicator.innerHTML = '<div class="scrollable-icon" />';
        if (tableElement.clientHeight > screen.height / 2) {
            scrollableIndicator.style.top = '500px';
        }
        if (wrapperElement && tableElement.clientWidth > wrapperElement.clientWidth) {
            wrapperElement.appendChild(scrollableIndicator);
        }
        inViewPort(function () {
            return once(function () { return scrollableIndicator.classList.add('hide'); })();
        }, scrollableIndicator);
        // Table mobile responsiveness
        tableElement.classList.add('d-flex', 'd-md-table', 'flex-column');
        // Hide table header cells on mobile
        forEach(tableHeaderElements, function (th) { return th.classList.add('d-none', 'd-md-table-cell'); });
        forEach(tableRowElements, function (tr) {
            var tableCellElements = tr.querySelectorAll('td');
            tr.classList.add('d-flex', 'd-md-table-row', 'flex-column');
            forEach(tableCellElements, function (td, index) {
                td.classList.add('d-flex', 'd-md-table-cell');
                td.innerHTML = "<div class=\"d-md-none\">".concat(tableColumnText[index], "</div><div class=\"cell-value ml-auto\">").concat(td.innerHTML, "</div>");
            });
        });
    });
});
